import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, InputGroup, Spinner, Button, Alert } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa'; // برای آیکون جستجو

import { showError } from '../../../utils/toastHelper';
import { getServiceGroup } from '../api/ServiceApi';
import { getServitorCompany } from '../../home/api/HomeApi';
import Header from "../../../layouts/Header";
import Loading from "../../../layouts/Loading";

function stripTags(str) {
    const div = document.createElement("div");
    div.innerHTML = str;
    return div.textContent || div.innerText || "";
}

export default function Services() {
    const navigate = useNavigate();
    const { id } = useParams();

    const [loading, setLoading] = useState(true); // مقدار اولیه true برای نمایش لودر در اولین رندر
    const [services, setServices] = useState([]);
    const [group, setGroup] = useState(null);
    const [search, setSearch] = useState('');

    const [gID, setGID] = React.useState(0);

    React.useEffect(() => {

        const fetchData = async () => {
            try {

                const groupIdToSend = id ? parseInt(id, 10) : 0;
                if (groupIdToSend > 0) {
                    setGID(id);
                }
                if (!group) {
                    const data = await getServiceGroup(groupIdToSend);
                    setGroup(data?.data || []);
                }


                if (search.length === 0 || search.length > 2 ) {
                    const params = {
                        search : search.length > 2 ? search : '',
                        group_id: groupIdToSend,
                        vendor: localStorage.getItem('_vid') === "1" ? null : localStorage.getItem('_vid'),
                    }
                    const result = await getServitorCompany(1 , params);
                    setServices(result?.data.services );
                }


            } catch (err) {
                showError( err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();

    }, [id , search]);

    const handleServiceClick = (serviceId) => {
        // به صفحه جزئیات سرویس هدایت می‌شود
        navigate(`/service/${serviceId}`);
    };



    if (loading) return <Loading/>;

    let title = 'لیست خدمات '
    if (gID > 0) {
        title += group?.name
    }

    return (
        <>

            <Header title={title} hasBack={true}/>
            <div className="services-page">
                {/* بخش بنر و عنوان صفحه */}
                {group && (
                    <header className="services-header text-white text-center p-5 mb-5"
                    style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('${group.image}')`}}
                    >
                        <Container className='pt-4'>
                            <h1 className="display-4 fw-bold">{group.name || 'لیست خدمات'}</h1>
                            <p className="lead">{stripTags(group.description) || 'جدیدترین و بهترین خدمات را با ما تجربه کنید.'}</p>
                        </Container>
                    </header>
                )}

                <Container>
                    {/* نوار جستجو */}
                    <Row className="justify-content-center mb-5">
                        <Col md={8} lg={6}>
                            <InputGroup className="search-bar">
                                <Form.Control
                                    type="text"
                                    placeholder="جستجوی خدمات..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="border-0"
                                />
                                <InputGroup.Text className="bg-white border-0">
                                    <FaSearch />
                                </InputGroup.Text>
                            </InputGroup>
                        </Col>
                    </Row>

                    {/* لیست خدمات */}
                    <Row>
                        {services.length > 0 ? (
                            services.map(service => (
                                <Col key={service.id} md={6} lg={4} className="mb-4">
                                    <Card className="h-100 service-card" onClick={() => handleServiceClick(service.id)}>
                                        <Card.Img variant="top" src={service.image} alt={service.title} />
                                        <Card.Body className="d-flex flex-column">
                                            <Card.Title className="fw-bold">{service.title}</Card.Title>
                                            <Card.Text className="text-muted flex-grow-1 text-justify">

                                                <p dangerouslySetInnerHTML={{__html: service.description.substring(0, 100) + '...'} }>

                                                </p>

                                            </Card.Text>
                                            <Button  className="btn mt-auto w-100 align-self-start bg-primary-color">
                                                مشاهده جزئیات
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col className="text-center">
                                <p>هیچ خدماتی برای نمایش وجود ندارد.</p>
                            </Col>
                        )}
                    </Row>
                </Container>
            </div>
        </>
    );
}
